import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem
} from '@material-ui/core'
import { get, isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'

import { fetchPaymentCycleOptions } from 'api'
import { PAYMENT_CYCLE_DISCOUNT_TEXT } from 'app/pages/Class/Inventory/constants'

import * as Styles from './styles'

const PaymentCycle = ({
  disabled,
  currentBatchInfo,
  onBatchInfoChange,
  batchDetails
}) => {
  const [paymentCycles, setPaymentCycles] = useState([])
  useEffect(() => {
    ;(async () => {
      const paymentCycleResponse = await fetchPaymentCycleOptions()
      setPaymentCycles(paymentCycleResponse?.results?.[0]?.value)
    })()
  }, [])

  return (
    <FormControl fullWidth variant="outlined" disabled={disabled} size="small">
      <InputLabel id="payment-cycle-label">Payment Cycle</InputLabel>
      <Select
        labelId="payment-cycle-label"
        value={get(currentBatchInfo, 'paymentCycle', '')}
        onChange={(e) =>
          onBatchInfoChange(batchDetails?.uuid, 'paymentCycle', e.target.value)
        }
        label="Payment Cycle"
      >
        {paymentCycles.map((cycle) => (
          <MenuItem key={cycle.value} value={cycle}>
            {cycle.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>
        <Styles.PaymentHelperText>
          <strong>Note: </strong>
          {PAYMENT_CYCLE_DISCOUNT_TEXT}
        </Styles.PaymentHelperText>
      </FormHelperText>
    </FormControl>
  )
}

export default PaymentCycle
